module.exports = __webpack_public_path__ + "img/Banner01.57c4b428.jpg";